import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModelViewerComponent } from './model-viewer/model-viewer.component';
import { ArticlesComponent } from './articles/articles.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/guards/auth-guard';
import { DxfToJpgComponent } from './dxf-to-jpg/dxf-to-jpg.component';
import { ArticleViewerComponent } from "./article-viewer/article-viewer.component";
import { SystemsComponent } from './systems/systems.component';
import { ArticlesManagementComponent } from './articles-management/articles-management.component';
import { RulesDashboardComponent } from './rules-dashboard/rules-dashboard.component';
import { RulesManagementComponent } from './rules-management/rules-management.component';
import { MatingRuleEditComponent } from './rules-management/mating-rule-edit/mating-rule-edit.component';
import { LandingComponent } from './landing/landing.component';
import { Joint } from '@schuco-vcl/unified-model';
import { JointRulesEditComponent } from './rules-management/joint-rule-edit/joint-rules-edit.component';
import { DecisionTreeComponent } from './decision-tree/decision-tree.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'landing', component: LandingComponent },
  { path: 'articles', canActivate: [AuthGuard], component: ArticlesComponent },
  { path: 'article-viewer', canActivate: [AuthGuard], component: ArticleViewerComponent },
  { path: 'viewer', canActivate: [AuthGuard], component: ModelViewerComponent },
  { path: 'dxf-to-jpg', canActivate: [AuthGuard], component: DxfToJpgComponent },
  { path: 'systems', canActivate: [AuthGuard], component: SystemsComponent },
  { path: 'articles-management', canActivate: [AuthGuard], component: ArticlesManagementComponent },
  { path: 'rules-dashboard', canActivate: [AuthGuard], component: RulesDashboardComponent },
  { path: 'rules/:type', canActivate: [AuthGuard], component: RulesManagementComponent },
  { path: 'rules/mating/edit/:id', canActivate: [AuthGuard], component: MatingRuleEditComponent },
  {path: 'rules/joint/edit/:id', canActivate: [AuthGuard], component: JointRulesEditComponent },
  { path: 'decision-tree', canActivate: [AuthGuard], component: DecisionTreeComponent },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
